import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection";

function Advertisement() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="Advertisement" backgroundImage={homebanner} />

  <div className="md:container mx-auto px-6 sm:px-6 py-10 flex flex-col items-center justify-center min-h-[60vh] text-center">
<svg
            className="animate-pulse mb-6 w-16 h-16 text-primarycolor"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3" />
            <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

          <h2 className="md:text-3xl text-xl font-bold text-gray-900 mb-4">
            Content Will Be Updated Soon
          </h2>
          <p className="text-gray-600 max-w-xl">
            We are working hard to bring you this content. Please check back shortly for updates.
          </p>
 

 
  <br/>
   
 
</div>

        <Footer />
      </div>
    </>
  );
}

export default Advertisement;
